// extracted by mini-css-extract-plugin
export var imageBlock = "page-teaser-module--image-block--mOX-A";
export var image = "page-teaser-module--image--1Qszn";
export var textBlock = "page-teaser-module--text-block--2vk7W";
export var text = "page-teaser-module--text--1d5ml";
export var container = "page-teaser-module--container--r1H5J";
export var imageRight = "page-teaser-module--image-right--1g9Te";
export var imageLeft = "page-teaser-module--image-left--i_DOK";